<p>{{ data.content || '' }}</p>
<div class="button-box">
  <button mat-flat-button (click)="close()" class="cancel-button">{{ data.actionContent || '關閉' }}</button>
</div>
